export const JS_TYPES = {
    STRING: "string",
    NUMBER: "number",
    BOOLEAN: "boolean",
    UNDEFINED: "undefined",
    OBJECT: "object",
    FUNCTION: "function",
    BIGINT: "bigint",
    SYMBOL: "symbol",
  } as const;
  
  export type JSTypeKey = keyof typeof JS_TYPES;
  export type JSTypeValue = typeof JS_TYPES[JSTypeKey];
  